import React, { useRef, useState } from 'react';
import classnames from 'classnames';

import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';

import DirectionButton from 'components/atoms/DirectionButton';
import Link from 'components/atoms/Link';
import useMedia from 'util/hook/useMedia';

import { BannerResource } from 'util/api/swaggerApi/data-contracts';

import styles from './index.module.css';

interface BannerCarouselProperty {
	data: BannerResource[];
	className?: string;
}

const BannerCarousel: React.FC<BannerCarouselProperty> = ({ data, className }) => {
	const timePerSlide = 5000;
	const progressBar = useRef<HTMLDivElement>(null);
	const onAutoplayTimeLeft = (swiper: Swiper, timeLeft: number) => {
		if (!progressBar.current) return;
		const swiperWidth = swiper.width;
		const widthPerMs = swiperWidth / timePerSlide;
		// eslint-disable-next-line no-mixed-operators
		progressBar.current.style.width = `${swiperWidth - timeLeft * widthPerMs}px`;
	};
	const media = useMedia();
	const [active, setActive] = useState(0);

	return (
		<SwiperComponent
			loop
			centeredSlides
			autoplay={{
				delay: timePerSlide,
				disableOnInteraction: false,
			}}
			onAutoplayTimeLeft={onAutoplayTimeLeft}
			pagination={{
				el: `.${styles.swiperPagination}`,
				clickable: true,
				renderBullet: (_, customClassName: string) =>
					`<span class="${styles.swiperPaginationBullet} ${customClassName}"></span>`,
				bulletActiveClass: styles.swiperPaginationBulletActive,
			}}
			navigation={{
				prevEl: '.banner-swiper-prev',
				nextEl: '.banner-swiper-next',
			}}
			modules={[Autoplay, Pagination, Navigation]}
			className={classnames(styles.swiper, className)}
			onActiveIndexChange={swiper => setActive(swiper.realIndex)}
		>
			<div className="banner-swiper-prev" style={active === 0 ? { display: 'none' } : {}}>
				<DirectionButton
					direction="left"
					appear="filling"
					handleClick={() => {}}
					className={classnames(styles.direction, styles.left)}
				/>
			</div>
			{data.map(item => (
				<SwiperSlide className={styles.swiperSlide} key={item.id}>
					<Link to={item.link} type="external" className={styles.imgLink} showPointer={!!item.link}>
						<img src={media === 'desktop' ? item.image : item.imageMobile} alt={item.altText} />
					</Link>
				</SwiperSlide>
			))}
			<div
				className="banner-swiper-next"
				style={active === data.length - 1 ? { display: 'none' } : {}}
			>
				<DirectionButton
					direction="right"
					appear="filling"
					handleClick={() => {}}
					className={classnames(styles.direction, styles.right)}
				/>
			</div>
			<div className={styles.swiperPagination} />
			{/* {data.length >= 2 && <div className={styles.progress} ref={progressBar} />} */}
		</SwiperComponent>
	);
};

export default BannerCarousel;
